<app-header></app-header>
<app-botao-chat></app-botao-chat>
<!-- RESPONSE CONCLUIR SOLICITACAO -->
<app-loading-generico [loadingGenerico]="loading"></app-loading-generico>
<app-alert-concluido [alertConcluido]="concluirSolicitacaoApi===true" alertConcluidoTitulo="Solicitação de 2ª via concluída"
[alertConcluidoMensagem]="alertConcluidoMensagem" (alertConcluidoFechou)="eventoAlertConcluido($event)"></app-alert-concluido>
<app-alert-erro [alertErro]="concluirSolicitacaoApi===false" [mensagemErro]="alertErroMensagem" (alertErroFechou)="eventoAlertErro($event)"></app-alert-erro>

<!-- SOLICITACAO 2a VIA -->
<div class="container py-4" >
  <div class="row">
    <div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Solicitação de 2ª via de cartão
          <button class="btn-icon" (click)="goBackPage()">

          </button>
          <i class="fa fa-arrow-left botao-setinha-voltar" aria-hidden="true"></i>
        </h1>
        <p class="paragrafo mb-4">Preencha o formulário e solicite</p>
        <!-- INFO 2 from input-->
        @if (dadosSegundaViaCartaoApi) {
          <div>
            <div class="row mb-4">
              <div class="col-4">
                <span class="label-escuro">Produto</span>
                <p> {{ descricaoProduto }} </p>
              </div>
              <div class="col-2">
                <span class="label-escuro">Emissão</span>
                <p> {{ dataEmissao }} </p>
              </div>
            </div>
            <form (ngSubmit)="concluirSolicitacao()" [formGroup]="solicitacaoForm">
              <!-- SELECT -->
              <div class="row mb-4">
                <div class="col-12 col-lg-6 mb-3">
                  <label class="label-menor label-escuro" for="tipoSolicitacao">TIPO DE SOLICITAÇÃO</label>
                  <app-select
                    [form]="solicitacaoForm"
                    name="tipoSolicitacao"
                    [options]="listaTipoSolicitacao"
                    optionValue="id"
                    id="tipoSolicitacao"
                    defaultDescription="Selecione"
                    optionText="descricao">
                  </app-select>
                </div>
              </div>
              <!-- TEXTAREA -->
              <div class="row mb-4">
                <div class="col-12 mb-3">
                  <label class="label-escuro" for="observacoes">
                    OBSERVAÇÕES (DESCREVA O MOTIVO E/OU AS INFORMAÇÕES DA SUA SOLICITAÇÃO)
                  </label>
                  <textarea class="form-control" id="observacoes" formControlName="observacoes" rows="7"></textarea>
                </div>
              </div>
              <!-- BOTOES -->
              <div class="row mb-3 d-flex justify-content-end">
                <div class="col-auto">
                  <button type="button" class="botao" (click)="goBackPage()">CANCELAR</button>
                </div>
                <div class="col-auto">
                  <button type="submit" class="botao-concluir-solicitacao" [ngClass]="{ 'disabled': !solicitacaoForm.valid }"
                  [disabled]="!solicitacaoForm.valid">CONCLUIR SOLICITAÇÃO</button>
                </div>
              </div>
            </form>
          </div>
        }
        <!-- CARREGAMENTO / ERRO -->
        @if (dadosSegundaViaCartaoApi === null || dadosSegundaViaCartaoApi === false) {
          <app-api-state
            [state]="dadosSegundaViaCartaoApi"
            loadingText="Consultando dados de solicitação de 2ª via ..."
            errorText="Ocorreu um erro na consulta dos dados de solicitação de 2ª via.">
          </app-api-state>
        }
      </div>
    </div>
  </div>
</div>

<!-- HISTORICO DE OCORRENCIAS -->
<div class="container py-4" >
  <div class="row">
    <div class="col-12">
      <div class="card">
        <h1 class="titulo">Histórico de ocorrências</h1>
        <p class="paragrafo mb-4">Histórico das últimas ocorrências</p>
        @if (historicoSolicitacaoApi) {
          <div class="table-hover table-responsive">
            <table class="table">
              <caption>Tabela com histórico de ocorrências do usuário</caption>
              <thead>
                <tr>
                  <th scope="col" >Nº DA OCORRÊNCIA</th>
                  <th scope="col" >DATA DE EMISSÃO</th>
                  <th scope="col" >TIPO DE ENTRADA</th>
                  <th scope="col" >TIPO DE OCORRÊNCIA</th>
                  <th scope="col" >CARTÃO</th>
                  <th scope="col" >SITUAÇÃO</th>
                </tr>
              </thead>
              <tbody>
                @for (oco of listaHistoricoOcorrencias; track oco) {
                  <tr>
                    <td class="align-middle"> {{ oco.numeroOcorrencia }} </td>
                    <td class="align-middle"> {{ oco.dataEmissao }} </td>
                    <td class="align-middle"> {{ oco.tipoEntrada }} </td>
                    <td class="align-middle"> {{ oco.tipoOcorrencia }} </td>
                    <td class="align-middle"> {{ oco.cartao }} </td>
                    <td class="align-middle"> {{ oco.situacao }} </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
        <!-- CARREGAMENTO / ERRO / VAZIO -->
        @if (listaHistoricoOcorrencias === null || listaHistoricoOcorrencias === false || listaHistoricoOcorrencias === undefined) {
          <app-api-state
            [state]="listaHistoricoOcorrencias"
            loadingText="Consultando dados de histórico de ocorrências ..."
            errorText="Ocorreu um erro na consulta dos dados de histórico de ocorrências."
            emptyText="Não existe histórico de ocorrências para esse usuário.">
          </app-api-state>
        }
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
